import { selectAuth } from '@brands/store/selectors/auth';
import React from 'react';

import { useAppSelector } from '../../../../hooks/useReduxHook';
import SelectProviderDetails from './SelectProviderDetails';

const SelectProviderDetailsRoute: React.FC = () => {
  const { userInfo } = useAppSelector(selectAuth);
  if (!userInfo) {
    return null;
  }
  return <SelectProviderDetails />;
};

export default SelectProviderDetailsRoute;
